import service from '@/utils/server';

const modName='/bd/statusUpdate/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};
export const initOrderNo = data => {
  return service({
    url: modName + 'orderStatus/'+data,
    method: 'post',
  });
};
export const initMivDate = data => {
  return service({
    url: modName + 'orderMiv/'+data,
    method: 'post',
  });
};
//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  });
};
//模板下载
export const downtemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

//在途导入
export const updateToBUpdate = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  return service({
    ...config,
    url: modName + 'updateToBUpdate',
    method: 'post',
    data
  });
};
//首次到达时间导入
export const updateToBFirstArrivalTime = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  return service({
    ...config,
    url: modName + 'updateFirstArrivalTime',
    method: 'post',
    data
  });
};
//完成时间导入
export const updateToBIntCompletionTime = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  return service({
    ...config,
    url: modName + 'updateIntCompletionTime',
    method: 'post',
    data
  });
};
//延迟原因数据导入
export const updateToBIntDelayReson = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  return service({
    ...config,
    url: modName + 'updateIntDelayReson',
    method: 'post',
    data
  });
};


/**
 * 上传图片提交
 */
export const upoladImg = process.env.BASE_URL + '/common/web/uploadImg' + '/uploadImg?businessNo=mivImg';

export const arrivedSubmit = data => {
  return service({
    url: modName + 'arrivedSubmit',
    method: 'post',
    data
  })
};
//导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/toBUpdate/statusUpdate/api/index.js